import { useState } from "react";
import { Pencil, Save, X } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";

const JobPosting = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [jobList, setJobList] = useState([
        { id: 1, jobTitle: "PHP Developer0-JB00136", firstName: "John", lastName: "Doe", phone: "1234567890", email: "john@example.com" }
    ]);
    const [editList, setEditList] = useState([]);

    const handleAddRow = () => {
        setEditList([
            ...editList,
            { id: editList.length + 1, jobTitle: "", firstName: "", lastName: "", phone: "", email: "" }
        ]);
    };

    const handleChange = (id, e) => {
        const { name, value } = e.target;
        setEditList((prevList) =>
            prevList.map((item) => (item.id === id ? { ...item, [name]: value } : item))
        );
    };

    const handleSave = () => {
        const newJobs = editList.map((item, index) => ({
            id: jobList.length + index + 1,
            jobTitle: item.jobTitle || "Unknown Job",
            firstName: item.firstName || "N/A",
            lastName: item.lastName || "N/A",
            phone: item.phone || "N/A",
            email: item.email || "N/A"
        }));

        setJobList([...jobList, ...newJobs]);
        setEditList([]);
        setIsEditing(false);
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Assigned - Job Postings</h5>
                <div>
                    {isEditing && (
                        <button onClick={handleSave} className="btn btn-success btn-sm me-2">
                            <Save size={18} className="me-1" /> Save
                        </button>
                    )}
                    <button onClick={() => setIsEditing(!isEditing)} className="border-0 bg-transparent">
                        {isEditing ? <X className="text-danger" size={20} /> : <Pencil className="text-primary" size={20} />}
                    </button>
                </div>
            </div>

            {/* Upper Table */}
            <div className="card-block">
                <div className="table-responsive mt-2">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Job Postings</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Phone</th>
                                <th>Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            {jobList.map((job) => (
                                <tr key={job.id}>
                                    <td>{job.id}</td>
                                    <td>{job.jobTitle}</td>
                                    <td>{job.firstName}</td>
                                    <td>{job.lastName}</td>
                                    <td>{job.phone}</td>
                                    <td>{job.email}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Lower Editable Table */}
                {isEditing && (
                    <div className="table-responsive mt-2">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Job Posting</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Phone</th>
                                    <th>Email Id</th>
                                </tr>
                            </thead>
                            <tbody>
                                {editList.map((row) => (
                                    <tr key={row.id}>
                                        <td>
                                            <select
                                                name="jobTitle"
                                                className="form-control"
                                                value={row.jobTitle}
                                                onChange={(e) => handleChange(row.id, e)}
                                            >
                                                <option value="">Select Job</option>
                                                <option value="PHP Developer">PHP Developer</option>
                                                <option value="Magento Developer">Magento Developer</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="firstName"
                                                className="form-control"
                                                value={row.firstName}
                                                onChange={(e) => handleChange(row.id, e)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="lastName"
                                                className="form-control"
                                                value={row.lastName}
                                                onChange={(e) => handleChange(row.id, e)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="tel"
                                                name="phone"
                                                className="form-control"
                                                value={row.phone}
                                                onChange={(e) => handleChange(row.id, e)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="email"
                                                name="email"
                                                className="form-control"
                                                value={row.email}
                                                onChange={(e) => handleChange(row.id, e)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <button className="btn btn-primary btn-sm mt-2" onClick={handleAddRow}>
                            <FontAwesomeIcon icon={faPlus} /> Add More
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default JobPosting;
